import { Button, CloseSVG, Icon } from "@newsela/angelou";
import { useStandardsModalContext } from "@/search/NewSearchPageMVP/provider/StandardsModalProvider";
import {
  actionButtonsCss,
  actionContainerCss,
  closeButtonCss,
  confirmWrapperCss,
  confirmationTextCss,
  modalActionCss,
  modalHeaderCss,
  wrapperContainerCss,
} from "./StandardsConfirmAction.styles";

interface StandardsLoadingSpinnerProps {
  children: React.ReactNode;
}

export const StandardsConfirmAction = ({
  children,
}: StandardsLoadingSpinnerProps) => {
  const {
    getters: {
      standardsSetMode,
      isConfirmActionModalOpen,
      operationErrorMessage,
    },
    handlers: { closeConfirmModal, handleApplyConfirmModal },
  } = useStandardsModalContext();

  const confirmationText =
    operationErrorMessage !== ""
      ? operationErrorMessage
      : "If you delete this set of standards, you won't be able to get it back. Are you really sure you want to delete?";

  return (
    <div css={wrapperContainerCss} data-testid="standards-confirm-container">
      {children}
      {isConfirmActionModalOpen && (
        <div css={confirmWrapperCss} data-testid="standards-confirm-action">
          <div css={modalActionCss}>
            <div css={actionContainerCss}>
              {operationErrorMessage === "" && (
                <div css={modalHeaderCss}>
                  <Button
                    flavor={Button.flavors.muted}
                    onClick={() => closeConfirmModal(standardsSetMode)}
                    __cssFor={{
                      root: closeButtonCss,
                    }}
                    dataProps={{
                      "data-qa-selector":
                        "standard-set-confirm-action-modal-close-button",
                    }}
                  >
                    <Icon size={Icon.sizes.sm} SvgComponent={CloseSVG} />
                  </Button>
                </div>
              )}
              <div css={confirmationTextCss}>{confirmationText}</div>
              <div css={actionButtonsCss}>
                {operationErrorMessage === "" && (
                  <Button
                    size={Button.sizes.lg}
                    flavor={Button.flavors.secondary}
                    onClick={() => closeConfirmModal(standardsSetMode)}
                    dataProps={{
                      "data-qa-selector":
                        "standard-set-confirm-action-modal-cancel-button",
                    }}
                  >
                    Cancel
                  </Button>
                )}
                <Button
                  size={Button.sizes.lg}
                  flavor={Button.flavors.danger}
                  onClick={handleApplyConfirmModal}
                  dataProps={{
                    "data-qa-selector":
                      "standard-set-confirm-action-modal-confirm-button",
                  }}
                >
                  {operationErrorMessage !== "" ? "Confirm" : "Delete"}
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
